import { Breadcrumbs, Link, SxProps, Typography } from '@mui/material';
import Optional from '../Optional';
import { useTranslate } from '@jd/i18n';

type Props = {
  title: string;
  sx?: SxProps;
  crumbs?: {
    label: string;
    href: string;
  }[];
};

const Crumb = ({ title, href }: { title: string; href: string }) => (
  <Typography
    variant={'h6'}
    component={Link}
    href={href}
    sx={{ color: 'text.secondary' }}
  >
    {title}
  </Typography>
);

const BreadcrumbBar = ({ title, sx, crumbs }: Props) => {
  const t = useTranslate('menu.nav');
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      sx={{ mb: 2, ...sx, color: 'text.secondary' }}
    >
      <Crumb title={t('home')} href={'/'} />
      <Optional condition={!!crumbs?.length}>
        {crumbs?.map((crumb) => {
          return (
            <Crumb key={crumb.href} title={crumb.label} href={crumb.href} />
          );
        })}
      </Optional>
      <Typography variant={'h6'} component={'p'} sx={{ color: 'text.primary' }}>
        {title}
      </Typography>
    </Breadcrumbs>
  );
};

export default BreadcrumbBar;
